//@flow
import * as React from 'react'
import PropTypes from 'prop-types'

import { useProgressStyles } from './styles'

type ProgressProps = {
  percentage: number,
  customColor?: string,
  ProgressValueComponent?: React.Node
}

const Progress = ({ percentage, customColor, ProgressValueComponent, ...props }: ProgressProps) => {
  const classes = useProgressStyles(customColor)
  return (
    <div className={classes.progressWrapper} {...props}>
      <span
        className={classes.progressBar}
        style={{
          width: `${percentage}%`
        }}
      />
      <span className={classes.progressValue}>
        {ProgressValueComponent !== undefined ? ProgressValueComponent : `${percentage} %`}
      </span>
    </div>
  )
}

Progress.propTypes = {
  progress: PropTypes.number
}

export default Progress
